import script from "./WorkOrderInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkOrderInfo.vue?vue&type=script&setup=true&lang=ts"

import "./WorkOrderInfo.vue?vue&type=style&index=0&id=27049f5f&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27049f5f"]])

export default __exports__